import React, { useEffect, useState } from "react";
import { FaChalkboardTeacher, FaProjectDiagram, FaBriefcase } from "react-icons/fa";
import ScrollableCards from '../prograse/prograse';
import Work from '../work/work';
import { useSlider } from "../SliderContext"; 



const images = "./Banner/1610.jpg"
const images1 = "./Banner/megascale-brochure.png"



const Services = () => {
  const [courses, setCourses] = useState([]);
  const { setIsSliderOpen } = useSlider(); 

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`https://training.megascale.co.in/backend/get_courses.php`);
        const data = await response.json();
        setCourses(data.courses);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

   const Upscale  = [
     { id: 1, title: "Learn everything you want", icon: <FaChalkboardTeacher size={30} className="text-blue-700" /> },
     { id: 2, title: "Learn from top expert", icon: <FaProjectDiagram size={30} className="text-blue-700" /> },
     { id: 3, title: "Training internal HR", icon: <FaBriefcase size={30} className="text-blue-700" /> },
   ];

    return (
        <div >
            {/* Header Section */}
            <section className='pt-20'>
                <div
                    className="relative w-full min-h-[300px] bg-fixed bg-cover bg-center flex items-center justify-center overflow-hidden"
                    style={{ backgroundImage: "url('/Banner/banner-1.jpg')" }}
                >
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-white pt-24 z-10">
                        COURSES DETAILS
                    </h2>

                </div>
            </section>
            <section>
                <div className="flex flex-col md:flex-row items-center shadow-lg bg-white p-5 ">
                    {/* Left Section: Image */}
                    <div className="md:w-1/2 h-96 flex justify-center items-center">
                        <img
                            src={images}// Replace with actual path
                            alt="Megascale Logo"
                            className="w-96 h-auto object-contain  rounded-lg"
                        />
                    </div>
                    {/* Right Section: Content */}
                    <div className="md:w-1/2 text-gray-600  md:mt-0">
                        <p className="text-gray-500 font-bold mb-4 text-3xl leading-relaxed">
                            WHAT IS MEGASCALE ?
                        </p>
                        <p>
                            Megascale IT Skill Development Center is a Professional Web, Mobile and Software Development
                            Institute based in Surat India. Our Software Development Institute focus on PHP, Php Frameworks,
                            IOS, Android, Graphics and Digital Marketing. We are mainly focus on IT students who wants to learn
                            technologies and expands their knowledge. Additionally we provide part-time training for those students
                            who engage in their study. It will helps them to work in real world.
                        </p>
                    </div>
                </div>
            </section>

            <section className="bg-gray-100 py-10">
      <div className="container mx-auto px-4">
        <h1 className="text-center text-3xl md:text-4xl text-gray-600 font-semibold mb-5">
        Upscale your Carrer with MEGASCALE
        </h1>
        <p className="text-center text-xl md:text-2xl text-gray-600 mb-10">
        Upgrade your technical knowlegde here.
        </p>

        {/* Timeline Wrapper */}
        <div className="flex flex-col md:flex-row items-center justify-center w-full max-w-5xl mx-auto relative">
          {Upscale.map((Upscale, index) => (
            <div key={Upscale.id} className="relative flex-1 text-center">
              {/* Line Connector (show between first and second, second and third) */}
              {index !== 0 && (
                <div className="absolute top-10 -left-1/2 w-full h-[2px] bg-gray-300 hidden md:block"></div>
              )}

              {/* Circle with Icon */}
              <div className="w-20 h-20 bg-white rounded-full border-2 border-gray-300 flex items-center justify-center mx-auto shadow-md relative z-10">
                {Upscale.icon}
              </div>

              {/* Title */}
              <p className="mt-4 text-gray-700 font-medium">{Upscale.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-10">
      <div className="container mx-auto px-4">
        <h1 className="text-center text-3xl md:text-4xl text-blue-700 font-semibold mb-10">
          Explore Our Courses
        </h1>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course) => (
            <div key={course.id} className="bg-white border flex flex-col shadow-md p-6 rounded-lg relative">
               <div className="flex justify-end">
                <button className="flex right-0 bg-blue-600 text-white px-4 py-2 text-sm font-semibold rounded hover:bg-blue-700 transition"  onClick={() => setIsSliderOpen(true)}>
                 INQUIRY
               </button>
               </div>
              {/* Course Title */}
              <h2 className="text-2xl font-semibold text-gray-700 mb-4">{course.title}</h2>

              {/* Topics List */}
              <ul className="list-disc list-inside text-gray-600">
                  {JSON.parse(course.subtitles).map((topic, index) => (
                    <li key={index}>{topic}</li>
                  ))}
                </ul>

              {/* Brochure Download Button (Only if brochure exists) */}
              {course.pdf && (
                  <a
                    href={`https://training.megascale.co.in/backend/${course.pdf}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-block"
                  >
                  <img
                    src={images1} 
                    alt="Download Brochure"
                    className="w-32 mt-4"
                  />
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
    <ScrollableCards />
    <Work />
        </div>
    );
};

export default Services;